import '@code-dot-org/component-library/carousel/index.css';

// Export the Component Definition for use in Contentful Studio
export {VideoCarouselContentfulComponentDefinition} from './videoCarouselContentfulDefinition';
export {default} from './VideoCarousel';
